import { motion, useInView } from 'framer-motion'
import { useRef } from 'react'
import ticketIcon from 'src/Imgs/newIcons/money.png'
import grafickIcon from 'src/Imgs/newIcons/graphic.png'
import homeClock from 'src/Imgs/newIcons/homeClock.png'
import mouseIcon from 'src/Imgs/newIcons/branch.png'

function Benefits() {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, amount: 0.2 })

  return (
    <>
      <div className="flex justify-center md:w-[100%] my-[30px] md:my-[100px]">
        <div className="w-full px-4 lg:px-12">
          <div ref={ref} className="flex flex-col items-center px-4 lg:px-0">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5 }}
              className="my-[60px] flex justify-center"
            >
              <div className="w-[70%]">
                <h1 className="text-center text-2xl md:text-5xl font-bold text-Main">
                  Beneficios
                </h1>
                <h1 className="text-center text-md lg:text-xl mt-6">
                  Hacemos más fácil los procesos para que los restaurantes
                  puedan crecer y tener ingresos extras.
                </h1>
              </div>
            </motion.div>

            <nav className="">
              <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
                <motion.li
                  initial={{ opacity: 0, y: 30 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.1 }}
                  className="text-center my-[30px] flex flex-col items-center md:ml-[30px] md:mr-[30px]"
                >
                  <div className="containerLogo">
                    <img src={homeClock} width={50} height={50} alt="" />
                  </div>
                  <h1 className="cardTitle md:h-[50px]">Practicidad</h1>
                  <p className="textoGeneral text-justify">
                    Las compras mediante este sistema suelen ser más
                    convenientes para los consumidores, ya que los procesos
                    entre la toma y entrega de pedido son mucho más ágiles.
                  </p>
                </motion.li>
                <motion.li
                  initial={{ opacity: 0, y: 30 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="text-center my-[30px] flex flex-col items-center md:ml-[30px] md:mr-[30px]"
                >
                  <div className="containerLogo">
                    <img src={mouseIcon} width={50} height={50} alt="" />
                  </div>
                  <h1 className="cardTitle md:h-[50px]">Reducción de costos</h1>
                  <p className="textoGeneral text-justify">
                    Reduce los gastos de operación por el hecho de mitigar los
                    costos de limpieza e higiene del establecimiento y la
                    cantidad de personal requerido para dicha tarea.
                  </p>
                </motion.li>
                <motion.li
                  initial={{ opacity: 0, y: 30 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.3 }}
                  className="text-center my-[30px] flex flex-col items-center md:ml-[30px] md:mr-[30px]"
                >
                  <div className="containerLogo">
                    <img src={ticketIcon} width={50} height={50} alt="" />
                  </div>
                  <h1 className="cardTitle md:h-[50px]">
                    Aumento de rentabilidad
                  </h1>
                  <p className="textoGeneral text-justify">
                    Este sistema eleva el flujo de pedidos pues deja que los
                    clientes hagan rápidamente su compra en tiempo real, lo que
                    conlleva a un aumento en los ingresos.
                  </p>
                </motion.li>
                <motion.li
                  initial={{ opacity: 0, y: 30 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  className="text-center my-[30px] flex flex-col items-center md:ml-[30px] md:mr-[30px]"
                >
                  <div className="containerLogo">
                    <img src={grafickIcon} width={50} height={50} alt="" />
                  </div>
                  <h1 className="cardTitle md:h-[50px]">
                    Crecimiento de los negocios
                  </h1>
                  <p className="textoGeneral text-justify">
                    Permite que más personas conozcan el restaurante. Adoptar
                    este sistema es una alternativa rentable y efectiva para
                    aumentar ventas y posicionar los negocios.
                  </p>
                </motion.li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  )
}

export default Benefits
